module.exports = __webpack_public_path__ + "img/left.c59a40dc.svg";